<!--
 * @Description: 用户右上角信息下拉菜单
 * @Author: xiawenlong
 * @Date: 2021-04-20 10:44:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-06-01 15:01:01
-->
<template>
  <div class="user-dropdown">
    <el-dropdown>
      <div class="user-info">
        <img :src="require('@/assets/avatar.png')" @click="handleSecretClick" />
        <span class="name">
          {{ userInfo.userName }}
          <i class="el-icon-caret-bottom"></i>
        </span>
      </div>
      <el-dropdown-menu slot="dropdown" class="user-info-dropdown">
        <el-dropdown-item>
          <a @click="logout"><i class="el-icon-switch-button"></i>退出登录</a>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import * as type from '@/store/action-types'
import { mapGetters, createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('user')
export default {
  data() {
    return {
      organization: [],
      pager: {
        current: 1,
        size: 100,
      },
      secretClickCount: 0,
      secretClickTimer: null,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {},
  methods: {
    ...mapActions([type.LOGOUT]),
    logout() {
      this[type.LOGOUT]()
    },
    handleSecretClick() {
      this.secretClickCount++
      clearTimeout(this.secretClickTimer)
      this.secretClickTimer = setTimeout(() => {
        this.secretClickCount = 0
      }, 2000)
      if (this.secretClickCount >= 10) {
        this.secretClickCount = 0
        const current = sessionStorage.getItem('rootUserSwitch') === '1'
        sessionStorage.setItem('rootUserSwitch', current ? '0' : '1')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.user-info-dropdown {
  /deep/ .el-dropdown-menu__item {
    padding: 0;
    a {
      display: block !important;
      padding: 0 20px;
    }
  }
}
.showorg a {
  display: block;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  border: 1px solid #e2e2e2;
}
.showorg a:hover {
  background: #b6927f;
  color: #fff;
}
.reference {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
